
export class WidgetKeyPair {
cod: string;
val: Object;
}

